module.exports = "/build/web/svg/practice-match.d64734bb130634e622443394c22f484f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/practice-match.svg
// module id = 180
// module chunks = 24